import {
  AfterViewInit,
  booleanAttribute,
  Component,
  ElementRef,
  inject,
  Input,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Collapse } from 'bootstrap';
import { filter } from 'rxjs';
import { LicensePopupService } from 'src/app/shared/services/license-popup/license-popup.service';

@Component({
  selector: 'app-menu-list',
  imports: [],
  templateUrl: './menu-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './menu-list.component.scss',
})
export class MenuListComponent implements AfterViewInit {
  @Input() public id!: string;
  @Input() public dropId!: string;
  @Input() public title!: string;
  @Input() public icon!: string;
  @Input() public firstRoute!: string;
  @Input({ transform: booleanAttribute }) public disabled = false;

  @ViewChild('dropDown') private dropDown!: ElementRef;
  @ViewChild('dropdownToggle') private dropdownToggle!: ElementRef;

  protected show: boolean = false;

  private readonly router = inject(Router);
  private readonly licensePopupService = inject(LicensePopupService);

  constructor() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => setTimeout(() => this.checkActiveRoute(), 0));
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.checkActiveRoute(), 0);
  }

  protected onKeydown(event: KeyboardEvent): void {
    if (event.code !== 'Enter' && event.code !== 'Space') {
      return;
    }

    event.preventDefault();
    this.clicked();
  }

  protected clicked(): void {
    if (this.disabled) {
      this.licensePopupService.open(this.title);
      return;
    }

    this.router.navigate([this.firstRoute.toLowerCase()]);
  }

  private checkActiveRoute(): void {
    if (this.containsActiveRoute()) {
      this.show = true;
      return;
    }

    if (this.show && this.isOpen()) {
      new Collapse(this.dropDown.nativeElement).hide();
      this.show = false;
    }
  }

  private isOpen(): boolean {
    return !this.dropdownToggle.nativeElement.classList.contains('collapsed');
  }

  private containsActiveRoute(): boolean {
    for (const child of this.dropDown.nativeElement.children) {
      const classes = child.children[0].classList as DOMTokenList;
      if (classes.contains('activeRoute')) {
        return true;
      }
    }
    return false;
  }
}
